// Feature flags for whole sections — أعلام أقسام مؤقتة.
// اقلب القيمة إلى true لإظهار القسم مجددًا (القوائم + الصفحات + خريطة الموقع + الواجهة العامة).
export const HOTELS_SECTION_ENABLED = false;
